import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { useConfig } from '../hooks/useConfig';

function ConstructionBanner() {
  const { getSiteFeatures } = useConfig();
  const [visible, setVisible] = useState(true);
  if (!getSiteFeatures().constructionBanner) return null;
  if (!visible) return null;

  return (
    <Box sx={{
      background: 'linear-gradient(90deg, #1a3a10 0%, #22501a 50%, #1a3a10 100%)',
      borderBottom: '1px solid rgba(46,168,75,0.3)',
      py: 0.6,
      px: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      gap: 1,
    }}>
      <Typography variant="body2" sx={{
        fontWeight: 600,
        fontSize: '0.78rem',
        letterSpacing: '-0.01em',
        textAlign: 'center',
        color: '#a8d8b0',
      }}>
        🚧 Football for Nerds is under active development — new features dropping soon.{' '}
        <span
          style={{ color: '#3ec45e', textDecoration: 'underline', cursor: 'pointer', fontWeight: 700 }}
          onClick={() => document.getElementById('waitlist-section')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Join the waitlist ↓
        </span>
      </Typography>

      <IconButton
        size="small"
        onClick={() => setVisible(false)}
        sx={{
          position: 'absolute',
          right: 8,
          color: '#6aaa78',
          p: 0.5,
          '&:hover': { color: '#a8d8b0', backgroundColor: 'rgba(46,168,75,0.1)' },
        }}
      >
        ✕
      </IconButton>
    </Box>
  );
}

export default ConstructionBanner;
